import React from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import Icon from './Icon';
import { Color, CommonProperties, CommonStyles } from '../styles';
import BaseText from './BaseText';

const VerticalSelect = ({ onChange, items, selected, ...rest }) => {
  return (
    <View {...rest}>
      {items &&
        items.map((item, index) => (
          <TouchableOpacity
            key={index}
            onPress={() => {
              onChange(item.value);
            }}
            style={[
              styles.button,
              {
                borderColor: items.length - 1 === index ? 'transparent' : 'rgba(0,0,0,.2)',
              },
            ]}
          >
            <View style={styles.innerButton}>
              <BaseText
                style={[
                  CommonStyles.body,
                  {
                    color: selected === item.value ? Color.primary : 'rgba(0,0,0,.5)',
                  },
                ]}
              >
                {item.label}
              </BaseText>
              <Icon
                name="check"
                color={selected === item.value ? Color.primary : 'rgba(0,0,0,.2)'}
              />
            </View>
          </TouchableOpacity>
        ))}
    </View>
  );
};

const styles = StyleSheet.create({
  button: {
    borderBottomWidth: 0.7,
    ...CommonProperties.p3,
  },
  innerButton: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});

export default VerticalSelect;
